import { IParamsApi } from '@/types/apis/params';

export type KeyOfAdvance = keyof NonNullable<IParamsApi.IChannelButton['advance']>;

export type KeyOfFormFields = 'id' | 'title' | 'placeholder' | 'isRequired' | 'isActive' | 'typeInput' | 'customId';
export type KeyOfBaseChannel = 'channel' | 'hoverText' | 'backgroundColor' | 'showOn' | 'value' | 'iconColor';
export type KeyOfCustomChannel = 'channel' | 'hoverText' | 'backgroundColor' | 'showOn' | 'value' | 'iconColor';
export type KeyOfMessageAdvance =
  | 'messengerChatWidget'
  | 'messengerProfileImage'
  | 'messengerWelcomeMessage'
  | 'messengerCtaText'
  | 'messengerTitle'
  | 'messengerPlaceholderText';

export type KeyOfCartAdvance =
  | 'isShowQuantityProductInCart'
  | 'isHiddenButtonInCartPage'
  | 'totalQuantityTextColorCartPage'
  | 'totalQuantityBackgroundColorCartPage';

export const LINKS = {
  WIX_REVIEW: `https://www.wix.com/app-market/add-review/${process.env.REACT_APP_BE_APP_ID}`,
};
